import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AccountFiltersContainer from '../../containers/parentSettings/configurations/AccountFiltersContainer';
import AccountEBPsContainer from '../../containers/parentSettings/configurations/AccountEBPsContainer';
import AccountDynamicFieldListsContainer from '../../containers/parentSettings/configurations/AccountDynamicFieldListsContainer';

const ConfigurationsRoutes = () => (
  <Routes>
    <Route path="/" element={<AccountFiltersContainer />} />
    <Route path="export-builder-plus-templates" element={<AccountEBPsContainer />} />
    <Route path="lists" element={<AccountDynamicFieldListsContainer />} />
  </Routes>
);

export default ConfigurationsRoutes;
